import React from 'react';
import Guide from '@/assets/icon/Guide.svg';
import cx from './index.module.scss';

interface PainLevelWrapperProps {
  afterMassage?: boolean;
  children?: React.ReactNode;
  bodyPartLabel?: string;
}

const PainLevelWrapper: React.FC<PainLevelWrapperProps> = props => {
  const { afterMassage = false, children, bodyPartLabel = '' } = props;

  return (
    <div className={cx('pain-level')}>
      <div className={cx('tips')}>
        <span className={cx('title')}>{afterMassage ? bodyPartLabel + '疼痛复测' : bodyPartLabel + '疼痛程度'}</span>
        <img src={Guide} alt="guide" />
        <span className={cx('desc')}>
          {afterMassage ? '请询问您顾客的理疗后的疼痛程度' : '请询问您顾客的疼痛感受选择以下疼痛程度'}
        </span>
      </div>
      {children}
    </div>
  );
};

export default PainLevelWrapper;
